module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "23144678283-oek7ncjmmrgkgmi2i56sc411gp71a8sp.apps.googleusercontent.com",
    SECRET: "",
  },
  posthog: {
    REACT_APP_PUBLIC_POSTHOG_HOST: "https://us.i.posthog.com",
    REACT_APP_PUBLIC_POSTHOG_API_KEY: "phc_4uwLGdOWWwYUEOROOmyTPQmVCAvtoEYp1g2749NlHSe",
  },
  facebook: {
    APP_ID: "",
  },
  google_sso:{
    CLIENT_ID: "782993175881-72jcp5o58hion4d0u5v9jq6l57i56ea0.apps.googleusercontent.com",
  },
  google_recaptcha: {
    SITE_KEY: "6Ld_N70qAAAAANm3VcO-HHeAdjmB9EpqssSzhjY1"
  }
}
